import invariant from 'react-utils/invariant';
export function validateStorageShape(storage, verifyIsStorageWrapper = true) {
  if (verifyIsStorageWrapper && !storage.isStorageWrapper) {
    console.warn('Consider using task-queues/storage/StorageWrapper to cache more expensive lookups.');
  }
  invariant(storage.setItem, 'expected storage to have function "setItem"');
  invariant(storage.getItem, 'expected storage to have function "getItem"');
  invariant(storage.removeItem, 'expected storage to have function "removeItem"');
}